import { canUseWindow } from './browserEnvironment'
import { getEnvConfig } from './processEnv'
import { PROTOCOL_PREFIX } from './types'

/**
 * Environment config getter for SERVER side environment
 *
 * Intended for use in `createIsomorphicEnvironment`
 *
 * @example
 * ```
 * const getEnvironment = createIsomorphicConfig({
 *   browserConfigFn: getClientEnvironment,
 *   serverConfigFn: getServerEnvironment,
 * })
 * ```
 */
export const getServerEnvironment = () => {
  const { ENVIRONMENT } = getEnvConfig()

  return ENVIRONMENT
}

export const getServerDomain = () => {
  const { DOMAIN } = getEnvConfig()

  return DOMAIN
}

/**
 * Whether the server is running on a local developer machine, driven by the
 * LOCAL_DEV flag. Decouples local-only behaviours from the ENVIRONMENT identity.
 */
export const getServerLocalDev = () => {
  const { LOCAL_DEV } = getEnvConfig()

  return LOCAL_DEV
}

/**
 * http on a local dev machine (so cookies are not forced secure over local http),
 * https everywhere else. Driven by the LOCAL_DEV flag. (Server-side equivalent of
 * `isLocalDev`; inlined to avoid a circular import with isomorphicEnvironment.)
 */
export const getServerProtocol = () =>
  getServerLocalDev() ? PROTOCOL_PREFIX.HTTP : PROTOCOL_PREFIX.HTTPS

export const getServerRecaptchaPublicKey = () => getEnvConfig().RECAPTCHA_PUBK
export const getServerCheckoutComPublicKey = () => getEnvConfig().CHECKOUT_COM_PUBK
export const getServerApplePayMerchantId = () => getEnvConfig().APPLE_PAY_MERCHANT_ID
export const getServerGooglePayMerchantId = () => getEnvConfig().GOOGLE_PAY_MERCHANT_ID
export const getServerAssetsDomain = () => getEnvConfig().ASSETS_DOMAIN

export const isServer = () => !canUseWindow()
